import React, { Suspense, forwardRef, useEffect, useState } from 'react'
import LoadingWindow from 'GeneralUI/Window/LoadingWindow.jsx'

// Summit has been using react-code-splitting library in Async.jsx but that was
// deprecated by the author in favor of React.lazy.  This mechanism solves
// some issues with error loops if a component errors on load (I believe in
// part due to STORE_WAITLIST_STREAM being dispatched repeatedly).  It also
// shows a loading state Window of the correct title, size, color, etc while
// the real Window code lazy-loads from the server.

// Note: Summit internal framework errors if class components are not returned
// by these HOCs

const AsyncWindow2 = WrappedComponent => {
  return forwardRef((props, ref) => {
    const [mounted, setMounted] = useState(false)
    useEffect(() => {
      // this is an ugly hack that should be looked into at some point. We are having issues where sometimes certain
      // windows don't return from suspense until after the next render. One example is:use the api test database,
      // load patient_id 2 (will load in the bch injection flow). Exit the workflow and load the standard injection
      // window from the windows menu. 75% of the time the window will never show but if you click on the screen somewhere
      // it will appear. By changing state 1 second after the window is first loaded this triggers the render that
      // will cause the window to display in these cases.
      const timer = setTimeout(() => { setMounted(true) }, 1000)
      return () => {
        clearTimeout(timer)
      }
    }, [])
    return (
      <Suspense fallback={<LoadingWindow ref={ref} mounted={mounted} {...props} />}>
        <WrappedComponent {...props} ref={ref}/>
      </Suspense>
    )
  })
}

export default AsyncWindow2
